<template>
  <div class="videoMerger">
    <merge-operation-panel></merge-operation-panel>
    <complete-panel></complete-panel>
  </div>
</template>

<script>
export default {
  name: 'VideoMerger',
  components: {
    MergeOperationPanel: () => import('@/components/videoMerger/mergeOperationPanel'),
    CompletePanel: () => import('@/components/videoMerger/completePanel')
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.videoMerger {
  width: 100%;
  height: 100%;
  background-color: #f6f7fb;
  border: 0px solid black;
  display: flex;
  padding: 17px 0 0px 0;
}
</style>
